import styled from 'styled-components/macro';
import { spacing } from '@material-ui/system';
import { Paper as MuiPaper } from '@material-ui/core';

export const drawerWidth = 258;

export const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const Drawer = styled.div`
  ${props => props.theme.breakpoints.up('xl')} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

export const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  min-width: 0;
`;

export const Paper = styled(MuiPaper)(spacing);

export const MainContent = styled(Paper)`
  flex: 1;
  background: ${props => props.theme.palette.background.default};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 32px;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }
`;
